import { forwardRef, ReactNode } from "react";
import { cx } from "class-variance-authority";

export interface ActionsContainerProps {
  className?: string;
  children: ReactNode;
  "data-testid"?: string;
}

/**
 *
 */
export const ButtonActionsContainer = forwardRef<any, ActionsContainerProps>(
  ({ className, children, "data-testid": dataTestId, ...rest }, ref) => {
    const classes = cx(
      className,
      "mt-5 flex items-center justify-end border-t-4 border-gray-400 pt-5",
    );
    const testId = dataTestId || "button-actions-container";

    return (
      <div ref={ref} {...rest} className={classes} data-testid={testId}>
        {children}
      </div>
    );
  },
);

export default ButtonActionsContainer;
